<template>
  <div class="big freeClinicPatient">
    <div class="page_title">医生义诊活动（患）</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 10px 20px 20px 20px;">

        <div class="top-header">
          <div class="search-box">
            <!-- 医生义诊活动名称 -->
            <div class="item">
              <span>医生义诊活动名称</span>
              <div class="item-content">
                <el-input v-model="doctorActivity.free_name"
                          size="small"
                          clearable
                          @keyup.enter.native="seachEnterFun"
                          placeholder="医生义诊活动名称"></el-input>
              </div>
              <el-button type="primary"
                         size="small"
                         style="margin-left:20px"
                         @click="getList">查询</el-button>
              <el-button size="small"
                         @click="restBtn">重置</el-button>
            </div>

          </div>
          <!-- 新增活动 -->
          <div style="margin-bottom: 10px;">
            <el-button type="primary"
                       size="medium"
                       :disabled="module_id_array[0]?!module_id_array.includes('1184'):false"
                       @click="addFree">添加</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table v-loading="tableLoading"
                    :data="activityData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column v-for="item in tableHeader"
                             :key="item.prop"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             :fixed="item.fixed">
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else>
                  {{ JSON.stringify(scope.row[item.prop]) == 'null' ? '' : scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作"
                             width="220"
                             align="center"
                             fixed="right">

              <template slot-scope="scope">
                <el-button type="text"
                           size="medium"
                           @click="toDetail(scope.row.free_id)"
                           :disabled="module_id_array[0]?!module_id_array.includes('1186'):false">详情</el-button>
                <el-button type="text"
                           :disabled="module_id_array[0]?!module_id_array.includes('1185'):false"
                           @click="delbtn(scope.row)">删除</el-button>
              </template>

            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination v-show="totalNum>0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getList" />
      </div>
    </div>
    <!-- 添加医生义诊活动 -->
    <el-dialog title="添加医生义诊活动"
               :visible.sync="freeVisible"
               width="650px"
               :close-on-click-modal="false"
               custom-class="cus-visibilityVisible">
      <div style="text-align:left;padding:20px;">
        <el-form :model="diaFreeForm"
                 :rules="rules"
                 ref="diaFreeRef"
                 label-width="100px"
                 class="visibilityVisible-ruleForm">
          <div class="cases-box">

            <el-form-item label="活动名称"
                          prop="free_name">
              <el-input v-model="diaFreeForm.free_name"
                        size="small"
                        clearable
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="活动说明"
                          prop="free_desc">
              <el-input v-model="diaFreeForm.free_desc"
                        size="small"
                        clearable
                        placeholder="请输入"></el-input>
            </el-form-item>

          </div>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="freeVisible=false"
                   size="medium"
                   plain>取 消</el-button>
        <el-button type="primary"
                   size="medium"
                   @click="diaFreeConfirm('diaFreeRef')">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import department from '@/api/department.js';
import Pagination from '@/components/Pagination/index';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      doctorActivity: {
        free_name: ''
      },
      tableHeader: [
        {
          label: '活动名称',
          prop: 'free_name',
          width: 'auto',
          align: 'center',
          fixed: 'left'
        },
        {
          label: '活动说明',
          prop: 'free_desc',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '医生人数',
          prop: 'count',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '创建时间',
          prop: 'create_time',
          width: '200',
          align: 'center',
          fixed: false
        }
      ],
      activityData: [],
      freeVisible: false,
      diaFreeForm: {
        free_name: '',
        free_desc: ''
      },
      rules: {
        free_name: [
          { required: true, max: 10, message: '请输入', trigger: 'blur' }
        ],
        free_desc: [{ max: 50, message: '请输入', trigger: 'blur' }]
      }
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD');
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign(this.pagination, this.doctorActivity);
      this.tableLoading = true;
      department.freeDoctorGroupList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.activityData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    // 添加
    addFree() {
      this.$refs.diaFreeRef ? this.$refs.diaFreeRef.resetFields() : '';
      this.freeVisible = true;
    },
    // 详情
    toDetail(free_id) {
      this.$router.push({
        path: '/home/department/freeClinicPatientDetail',
        query: {
          free_id
        }
      });
    },
    //删除
    delbtn(row) {
      let { free_id, count } = row;
      if (count) {
        this.$message.warning('已绑定医生, 不允许删除');
        return;
      }
      this.$confirm('确认删除该活动？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const loading = this.$loading();
          department
            .deleteFreeDoctorGroup({ free_id })
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success('删除成功');
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    restBtn() {
      for (let key in this.doctorActivity) {
        this.doctorActivity[key] = '';
      }
      this.getList();
    },
    diaFreeConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let params = Object.assign({}, this.diaFreeForm);
          department
            .addFreeDoctorGroup(params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success('保存成功');
                this.freeVisible = false;
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.freeClinicPatient {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>